export function toDate(value: string): number {
    return parseInt(value);
}
